/* eslint-disable no-useless-concat */
const baseName = '/dashboard';

module.exports = {
  manager: baseName + '/manager',
  impact: '/manager' + '/impact/:id/:employeeId1?/:employeeId2?'
};
